import WithdrawApprovalListTable from './WithdrawApprovalListTable';

export default WithdrawApprovalListTable;
